import React from "react";
import { totalItems, isLive } from "../../lib/inventorySkills";

// Slim sticky progress bar: player name, Anchors / Good / Rate Limiters totals, X/79 rated, jump to Step 3.
export function StickyProgressBar({ playerName, assessment }) {
  if (!assessment) return null;
  const r = (assessment.ratings || []).filter(isLive);
  const n = (v) => r.filter(x => x.rating === v).length;
  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 border-t border-white/10 bg-[#0a0a0a]/90 backdrop-blur-md" data-testid="sticky-progress">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-2 flex items-center gap-4 flex-wrap text-[10px] uppercase tracking-widest">
        <div className="font-heading text-sm tracking-wide text-white normal-case truncate">{playerName}</div>
        <div className="text-[#4ade80] font-bold" data-testid="sticky-anchors">{n("anchor")} Anchors</div>
        <div className="text-[#60a5fa] font-bold" data-testid="sticky-good">{n("good")} Good</div>
        <div className="text-[#f87171] font-bold" data-testid="sticky-limiters">{n("limiter")} Rate Limiters</div>
        <div className="text-[#a0a0a0]" data-testid="sticky-rated">{r.length}/{totalItems()} rated</div>
        <button onClick={() => document.querySelector('[data-testid="heading-assessment-review"]')?.scrollIntoView({ behavior: "smooth", block: "start" })}
          className="ml-auto px-3 py-1.5 bg-[var(--org-accent)] text-[#121212] font-bold tracking-[0.3em] hover:bg-[var(--org-accent-hover)]" data-testid="sticky-view-step3">View Review</button>
      </div>
    </div>
  );
}
